<template src="./index.html"></template>
<script>
// var _this=this
import bus from '../../util/bus';
import { checkoutUserPeriod } from '../../../api/home.js';
import confing from '../../../../configHttp.js';
import { updatePass } from '@/api/password';
export default {
	inject: ['reload'],
	data() {
		return {
			collapse: true,
			show: false,
			time: null,
			value: '',
            headerSelect: "",
			options: [
				{}
				// {
				// 	label: '重新登录',
				// 	value: 'loginout'
				// },
				// {
				// 	label: '修改密码',
				// 	value: 'ChangePassword'
				// }
			],
			listout: [{}],
			list: [],
			modify: false,
			userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
			suosq: this.$getdefultMonth(),
			confing: confing,
			headtext: '',

            formlist: [
                {
                    prop: 'dqPassword',
                    label: '当前密码',
                    type: 'input',
                    width: '220px',
                    ispassword: true,
                    isnotnull: true,
                },
                {
                    prop: 'xgPassword',
                    label: '修改密码',
                    type: 'input',
                    width: '220px',
                    ispassword: true,
                    isnotnull: true,
                    Customtips: '8位以上包含大小写字母、数字(不连续)、特殊字符',
                    Customrules: /^(?!.*(?:(\d)\1|01|12|23|34|45|56|67|78|89|98|87|76|65|54|43|32|21|10))(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F])[\da-zA-Z\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]{8,}$/
                },
                {
                    prop: 'qrPassword',
                    label: '确认密码',
                    width: '220px',
                    type: 'input',
                    ispassword: true,
                    isnotnull: true,
                }
            ],
            formdata: {
                dqPassword: '',
                xgPassword: '',
                qrPassword: ''
            },
		};
	},
	created() {
		this.options = [];
		if (this.confing.company == 'hls') {
			this.options.push({
				label: '返回主页',
				value: 'loginout'
			});
		} else {

            this.options.push( {
                label: '修改密码',
                value: 'ChangePassword'
            });

			this.options.push({
				label: '退出登录',
				value: 'loginout'
			});
		}
        let auth = this.$route.meta.requiresAuth || this.$route.meta.requiresAuth === undefined; // 查询当前页面是否可以,跳过登录，直接跳转
        if ((this.$emptyandnull(this.userInfo) || this.$emptyandnull(localStorage.getItem('meaus'))) && auth) {
			this.$router.push('/login');
		}
		if (this.$notemptyandnull(localStorage.getItem('zcfgmeaus'))) {
			this.headtext = '税务知识库';
		} else if (this.$notemptyandnull(localStorage.getItem('hmdglmeaus'))) {
			this.headtext = '税务风控';
		} else {
			this.headtext = '纳税申报';
		}
		this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
	},
	methods: {
		BackHome(e) {
			this.$router.push('/homepage');
		},
		suosqchange(e) {
			checkoutUserPeriod({ suosq: this.suosq }).then(res => {
				if (res.data.code == 1) {
					this.$message.success(res.data.msg);
					localStorage.setItem('suosq', e);
					this.reload();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		tz(e) {
			this.$router.push('/' + e);
		},
		forheadchange(e) {
			if (e == 'loginout') {
				if (this.enableFamilyLogin && (this.projectName == 'PRODUCT' || this.projectName == '')) {
					localStorage.setItem('portalLogin', portalLogin);
					window.location.href = this.familyLoginUrl + '?token=' + token;
				}
				if (this.confing.company == 'hls') {
					this.$router.push('/homepage');
				} else {
					localStorage.removeItem('token');
					localStorage.clear();
					this.$router.push('/login');
				}
			} else if (e === 'ChangePassword') {
                this.modify = true;
            } else {
				this.modify = true;
			}
		},
		active_show() {
			this.show = true;
		},

		inputx(e) {
			this.listout = [];
			this.list.map(item => {
				item.children.map(item1 => {
					if (item1.resName.indexOf(e.target.value) == 0) {
						if (this.listout.length == 0) {
							this.listout.push({
								resName: item.resName,
								children: [{ ...item1 }]
							});
						} else {
							this.listout.map(item2 => {
								if (item2.resName == item.resName) {
									item2.children.push({ ...item1 });
								} else {
									this.listout.push({
										resName: item.resName,
										children: [{ ...item1 }]
									});
								}
							});
						}
					}
				});
			});
			if (e.target.value == '') {
				this.Search();
			}
		},
		Search() {
			this.listout = [];
			this.list.map(item => {
				this.listout.push({ ...item });
			});
		},


        nextpassword(){
            this.$refs.taxform.submitForm()
        },
        getdata(e){
            let userId = JSON.parse(localStorage.getItem('userInfo'))
            let params = {
                userId:userId.id,
                currentPass:this.formdata.dqPassword,
                newPass:this.formdata.xgPassword,
                confPass:this.formdata.qrPassword,
            }
            updatePass(params).then(res=>{
                if(res.data.code==1){
                    this.modify = false
                    this.$message.success('密码修改成功')
                    this.forout()
                }else{
                    this.$message.error(res.data.msg)
                }
            })
        },
        forout(){
            localStorage.clear();
            this.$router.push('/login');
        },
	},
	mounted() {
		this.list = JSON.parse(localStorage.getItem('meausout'))[JSON.parse(localStorage.getItem('meausout')).length - 1].children;
		this.Search();
		bus.$on('log', content => {
			this.show = false;
			this.Search();
		});
	}
};
</script>

<style scoped>
@import url('./index.css');
</style>
<style scoped lang="less">
.backinput {
	/deep/.el-input--small .el-input__inner {
		background-color: white !important;
	}
}
/deep/.el-input--small .el-input__inner {
	border: none;
	background-color: #354257;
}

/deep/.el-icon-search {
	font-size: 19px;
	position: relative;
	top: 3px;
	margin-left: 17px;
}
</style>
